import Br from './brazil'
import In from './india'
import Id from './indonesia'
import Vn from './vn'
import { Nation } from '@/types'
import { useStore } from '@/stores/main'
const { code } = useStore()
export function t() {
  console.log('code.value', code.value)
  switch (code.value) {
    case Nation.BR:
      return Br
    case Nation.IN:
      return In
    case Nation.ID:
      return Id
    case Nation.VN:
      return Vn
    default:
      return In
  }
}

export const InformationMap = {
  gender: '性别',
  age: '年龄',
  degree: '学历',
  city: '城市',
  career: '职业',
  income: '收入',
  interest: '爱好',
  marital_status: '婚姻状态',
  family_members: '家庭成员数',
  personality: '性格',
  faith: '信仰',
  real_name: '姓名',
  phone: '手机号',
  email: '邮箱',
  sport: '运动',
  book: '书籍',
  movie: '电影',
  music: '音乐',
  star: '明星',
  interest_city: '喜欢的城市',
  interest_country: '喜欢的国家',
  color: '喜欢的颜色',
  season: '季节',
  plant: '植物',
  animal: '动物',
}
